export default __webpack_public_path__ + "static/media/token.e45e52e9.png";